import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { translatedMessage } from '../../service/LanguageService';
import QuestionViewComponent from './QuestionViewComponent';
import { Divider } from 'primereact/divider';
import { CompetitionService } from '../../service/CompetitionService';
import MessagesDisplayDialogComponent from '../MessagesDisplayDialogComponent';

const SubjectProposalViewDialog = (props) => {
    const [proposal, setProposal] = useState({});
    const [dialogVisible, setDialogVisible] = useState(false);
    const [messagesDialogVisible, setMessagesDialogVisible] = useState(false);
    const [messages, setMessages] = useState([]);

    const toast = useRef(null);
    const competitionService = useMemo(() => new CompetitionService(), []);

    useEffect(() => {
        setProposal(props.value);
    }, [props]);

    useEffect(() => {
        setDialogVisible(props.visible);
    }, [props.visible]);

    const hideDialog = () => {
        if (typeof props.visibleSetter === 'function') {
            props.visibleSetter(false);
        }
        setDialogVisible(false);
    };

    const validate = () => {
        competitionService
            .validateSubjectProposal(props.value?.id)
            .then((_errors) => {
                if (_errors.length === 0) {
                    toast.current.show({ severity: 'success', summary: translatedMessage('competition.subjectProposal.validate.noErrors') });
                } else {
                    setMessages(_errors);
                    setMessagesDialogVisible(true);
                }
            })
            .catch((error) => toast.current.show({ severity: 'error', summary: translatedMessage(error), life: 5000 }));
        //validateSubjectProposal
    };

    const subjectDialogFooter = (
        <>
            {/*<Button label={translatedMessage('competition.subjectProposal.validate')} icon="pi pi-check" className="p-button-text" onClick={validate} />*/}
            <Button label={translatedMessage('generic.close')} icon="pi pi-times" className="p-button-text" onClick={hideDialog} />
        </>
    );

    return (
        <>

            <Dialog visible={dialogVisible} header={translatedMessage('competition.subjectProposal.details') + ' - ' + proposal?.subject?.name} modal className="pcn-dialog" footer={subjectDialogFooter} onHide={hideDialog}>
                <Toast ref={toast} />
                {proposal?.questions?.map((question, index) => {
                    return (
                        <div key={index}>
                            <QuestionViewComponent value={question} />
                            <Divider />
                        </div>
                    );
                })}
            </Dialog>

            {messagesDialogVisible && (
                <MessagesDisplayDialogComponent
                    visible={messagesDialogVisible}
                    severity="error"
                    dialogTitle="competition.subjectProposal.validate.title"
                    dialogInfo="competition.subjectProposal.validate.message"
                    messages={messages}
                    translate={false}
                    closeDialog={() => {
                        setMessagesDialogVisible(false);
                    }}
                />
            )}
        </>
    );
};

export default SubjectProposalViewDialog;
